import React from 'react';
import {
  corPorSituacao,
  SITUACAO_INTERVENCAO_OXY
} from './situacaoIntervencaoOxy';
import styles from './MapaObrasPublicasList.module.css';

const formatarPercentual = value => {
  if (!value) return '-';
  return `${Number(value.toFixed(2))}%`;
};

const formatarData = value => {
  if (!value) return '-';
  const [ano, mes, dia] = value.toString().split('-');
  return dia ? `${dia}/${mes}/${ano}` : value;
};

const MapaObrasPublicasList = ({
  obras,
  loading,
  obraExpandida,
  onObraClick,
  onVerObra,
  onImovelClick
}) => {
  if (loading) {
    return <div className={styles.textoInformativo}>Carregando obras...</div>;
  }

  if (!obras.length) {
    return (
      <div className={styles.textoInformativo}>Nenhuma obra encontrada.</div>
    );
  }

  const sorted = [...obras].sort((a, b) => {
    if (!a.dataPrevisaoTermino && !b.dataPrevisaoTermino) return 0;
    if (!a.dataPrevisaoTermino) return -1;
    if (!b.dataPrevisaoTermino) return 1;
    return b.dataPrevisaoTermino.localeCompare(a.dataPrevisaoTermino);
  });

  return (
    <>
      {sorted.map(obra => {
        const cor = corPorSituacao(obra.situacao);
        const expandida = obraExpandida === obra.idOxy;
        const situacaoLabel =
          SITUACAO_INTERVENCAO_OXY[obra.situacao] || obra.situacao;

        return (
          <div
            key={obra.idOxy}
            id={`obra-item-${obra.idOxy}`}
            style={{ '--situacao-cor': cor }}
          >
            <div
              className={`${styles.obraItem} ${
                expandida ? styles.obraItemExpandida : ''
              }`}
              onClick={() => onObraClick(obra.idOxy)}
              id={`obra-item-header-${obra.idOxy}`}
            >
              <div className={styles.obraItemHeader}>
                <strong style={{ fontSize: '13px' }}>
                  {`${obra.numero}/${obra.anoIntervencao}`}
                  {obra.codigoTCE ? ` - TCE: ${obra.codigoTCE}` : ''}
                </strong>
                <span className={styles.sendToRight}>
                  <span
                    style={{
                      background: cor,
                      color: '#fff',
                      borderRadius: '4px',
                      padding: '1px 6px',
                      fontSize: '11px'
                    }}
                  >
                    {situacaoLabel}
                  </span>
                </span>
              </div>
              <p className={styles.obraObjeto} title={obra.objeto}>
                {obra.objeto}
              </p>
              <p className={styles.obraInfo}>
                {!obra.imoveis.length
                  ? 'Sem imóveis'
                  : `${obra.imoveis.length} imóve${
                      obra.imoveis.length > 1 ? 'is' : 'l'
                    }`}
                {!!obra.percentual &&
                  ` - Conclusão: ${formatarPercentual(obra.percentual)}`}
                {!!obra.dataPrevisaoTermino &&
                  ` - Prev. término: ${formatarData(obra.dataPrevisaoTermino)}`}
              </p>
            </div>

            {expandida && (
              <div className={styles.obraDetalhes}>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => onVerObra(obra.idOxy)}
                >
                  Abrir Intervenção
                </button>
                <span>
                  Selecione o imóvel abaixo que deseja visualizar no mapa
                </span>
                {obra.imoveis.map((imovel, imIdx) => (
                  <div
                    key={imIdx}
                    id={`obra-item-imovel-${obra.idOxy}-${imIdx}`}
                    onClick={() => onImovelClick(obra, imIdx)}
                    className={styles.obraDetalhesImovel}
                  >
                    {imovel.descricaoBem && (
                      <strong style={{ display: 'block', fontSize: '11px' }}>
                        {imovel.descricaoBem}
                      </strong>
                    )}
                    {imovel.enderecoCompleto || 'Sem endereço cadastrado'}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default MapaObrasPublicasList;
